import PropTypes from 'prop-types';
import React from 'react';
import { Carousel } from 'components/Carousel/Carousel';

export const ResponsiveCarouselLg = ({ children, extraClass, handleSlide, loading }) => {
  if (loading || !children || !children.length) {
    return false;
  }

  return (
    <Carousel
      afterSlide={handleSlide}
      cellAlign="left"
      cellSpacing={10}
      className={extraClass}
      dragging={false}
      edgeEasing="easeCubicOut"
      showDesktopControlsTop
      slidesToShow={4}
      slidesToScroll={4}
      speed={150}
      width="100%">
      {children}
    </Carousel>
  );
};

ResponsiveCarouselLg.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element),
  extraClass: PropTypes.string,
  handleSlide: PropTypes.func,
  loading: PropTypes.bool,
};
